import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BrandLogo from "./component/BrandLogo";
import Navigation from "./component/Navigation";
import UserActions from "./component/UserAction";
// import SearchBar from "../header_component/SearchBar";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Check if we're on the home page
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    // Only add scroll listener on home page
    if (!isHomePage) {
      setIsScrolled(true); // Always "scrolled" state on non-home pages
      return;
    }

    const handleScroll = () => {
      // Change header style when scrolled past 80vh (hero section height)
      const heroHeight = window.innerHeight * 0.8;
      setIsScrolled(window.scrollY > heroHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  return (
    <div
      className={`fixed z-20 w-full sm:pt-[25px] sm:pb-[16px] transition-all duration-300 ${
        isScrolled || !isHomePage
          ? "bg-[#0D0D0D] border-b border-[#C8960C]/30 shadow-[0_2px_20px_rgba(200,150,12,0.15)]"
          : "bg-transparent "
      }`}
    >
      <div>
        <header
          className={`py-4 sm:py-0 px-[10px] xl:px-[135px] lg:px-[100px] md:px-[60px] flex justify-between items-center transition-colors duration-300 ${
            isScrolled || !isHomePage ? "text-[#FFFDE8]" : "text-white"
          }`}
        >
          <div className="hidden lg:block">
            <Navigation isScrolled={isScrolled || !isHomePage} />
          </div>
          <div className="text-2xl">
            <BrandLogo isScrolled={isScrolled || !isHomePage} />
          </div>
          <div className="flex gap-2">
            <UserActions isScrolled={isScrolled || !isHomePage} />
            <div className="lg:hidden my-auto align-middle pt-2 h-auto">
              <Navigation isScrolled={isScrolled || !isHomePage} />
            </div>
          </div>
        </header>
        {/* <div className='px-5 pb-3 sm:hidden'>
        <SearchBar/>
        </div> */}
      </div>
    </div>
  );
};

export default Header;
